import date from 'date-and-time';
import Papa from 'papaparse';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import useLeadImport from '../../../../data/useLeadImport';
import LoadingWheel from '../../../shared/LoadingWheel';


// jsonData is the finished export set: /lead/partialforexport has already applied the date range,
// dropped vehicles that failed lookup, and (unless the caller asked for them) dropped leads that
// were exported before. Nothing is filtered again here.
const JSONToCSVExporter = ({ displayColumnNames, columnNames, jsonData, isLoading }) => {
  const { exportLeads } = useLeadImport("JSONToCSVExporter");
  const [error, setError] = useState("");

  const exportToCSV = () => {
    if (jsonData.length === 0) {
      setError("No leads to export in this date range");
      return;
    }

    setError("");

    const rows = jsonData.map(row => columnNames.map(columnName => Object.byString(row, columnName)));

    //Format the various columns
    rows.forEach((row) => {
      row[6] = date.format(new Date(row[6]), "DD/MM/YYYY");
      row[10] = row[10] ? date.format(new Date(row[10]), "HH:mm DD/MM/YYYY") : "";
      row[21] = date.format(new Date(row[21]), "DD/MM/YYYY");
    });

    let csvContent = Papa.unparse({
      fields: displayColumnNames,
      data: rows
    })

    // Add the first two rows to match the CSV format
    var formatting = "Operator:,All Sites," + ",".repeat(displayColumnNames.length - 1 - 2) + "\r\n" + ",".repeat(displayColumnNames.length - 1) + "\r\n";
    csvContent = formatting + csvContent;

    let csvData = encodeURIComponent(csvContent);
    csvData = "data:text/csv;charset=utf-8," + csvData;

    const link = document.createElement("a");
    link.setAttribute("href", csvData);
    link.setAttribute("download", "export.csv");
    document.body.appendChild(link);

    link.click();

    //Send up IDs of leads we're exporting for the first time. Re-downloading a lead that was
    //already exported doesn't re-stamp it, so the "not yet exported" set stays meaningful.
    const leadIds = jsonData.filter(lead => !lead.exportedOn).map(lead => lead.id);

    if (leadIds.length > 0) {
      const body = { leads: leadIds };
      exportLeads.mutate(body, {
        onSuccess: () => {
          console.log("Success");
        },
        onError: () => {
          console.log("Error");
        }
      })
    }
  }

  //Gets nested object properties by string
  Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  }

  if (isLoading) return <LoadingWheel />;

  return (
    <div>
      <button
        type="button"
        className="inline-flex items-center rounded-md border border-transparent bg-primary-600 px-8 py-4 text-xl font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
        onClick={exportToCSV}>
        <DocumentArrowDownIcon
          className="-ml-2 mr-5 h-8 w-8"
          aria-hidden="true"
        />
        Download CSV ({jsonData.length})
      </button>
      {error &&
        <p className="mt-5 text-lg text-red-500">{error}</p>
      }
    </div>
  );
};

export default JSONToCSVExporter;
